import type { Messages } from './en.js';

/** Português (BR) — termos alinhados à landing (Linha do tempo, abas…). */
export const pt: Messages = {
  // ── nav ────────────────────────────────────────────────────────────────
  'nav.timeline': 'Linha do tempo',
  'nav.search': 'Buscar',
  'nav.duplicates': 'Duplicatas',
  'nav.collections': 'Coleções',
  'nav.import': 'Importar',
  'nav.trash': 'Lixeira',
  'nav.settings': 'Configurações',

  // ── common actions ─────────────────────────────────────────────────────
  'common.restore': 'Restaurar',
  'common.delete': 'Excluir',
  'common.cancel': 'Cancelar',
  'common.save': 'Salvar',
  'common.close': 'Fechar',
  'common.upgrade': 'Fazer upgrade',
  'common.upgradeToPro': 'Assinar o Pro',
  'common.search': 'Buscar',
  'common.tryAgain': 'Tentar de novo',
  'common.loading': 'Carregando…',
  'common.back': 'Voltar',
  'common.skip': 'Pular',
  'common.verify': 'Verificar',
  'common.resend': 'Reenviar',
  'common.free': 'Free',
  'common.pro': 'Pro',
  'common.clearFilters': 'Limpar filtros',
  'common.addToChrome': 'Adicionar ao Chrome',
  'toast.genericError': 'Algo deu errado. Tente novamente.',

  // ── plural units ───────────────────────────────────────────────────────
  'unit.tabs.one': '{count} aba',
  'unit.tabs.few': '{count} abas',
  'unit.tabs.many': '{count} abas',
  'unit.tabs.other': '{count} abas',
  'unit.sessions.one': '{count} sessão',
  'unit.sessions.few': '{count} sessões',
  'unit.sessions.many': '{count} sessões',
  'unit.sessions.other': '{count} sessões',
  'unit.items.one': '{count} item',
  'unit.items.few': '{count} itens',
  'unit.items.many': '{count} itens',
  'unit.items.other': '{count} itens',
  'unit.entries.one': '{count} entrada',
  'unit.entries.few': '{count} entradas',
  'unit.entries.many': '{count} entradas',
  'unit.entries.other': '{count} entradas',
  'unit.copies.one': '{count} cópia',
  'unit.copies.few': '{count} cópias',
  'unit.copies.many': '{count} cópias',
  'unit.copies.other': '{count} cópias',
  'unit.browsers.one': '{count} navegador',
  'unit.browsers.few': '{count} navegadores',
  'unit.browsers.many': '{count} navegadores',
  'unit.browsers.other': '{count} navegadores',

  // ── app shell ──────────────────────────────────────────────────────────
  'shell.searchPlaceholder': 'Buscar no seu vault…',
  'shell.saved': 'SALVAS',
  'shell.toggleTheme': 'Alternar tema',

  // ── timeline ───────────────────────────────────────────────────────────
  'timeline.empty.title': 'Seu vault está vazio — por enquanto',
  'timeline.empty.body':
    'Varra uma janela com a extensão do TabVault ou resgate seu velho cemitério do OneTab. Tudo cai aqui, e tudo pode ser buscado.',
  'timeline.empty.import': 'Importar suas abas',
  'timeline.empty.importOneTab': 'Importar do OneTab',
  'timeline.empty.tip': 'DICA: ⇧⌘S VARRE A JANELA ATUAL PELA EXTENSÃO',
  'timeline.noMatch.title': 'Nenhuma sessão combina com esses filtros',
  'timeline.noMatch.body': 'Tente um período maior, outro navegador ou desligue “só com conteúdo”.',
  'timeline.loadOlder': 'Carregar sessões mais antigas',
  'timeline.toast.sessionDeleted': 'Sessão excluída',
  'timeline.toast.loadFailed': 'Não foi possível carregar essa sessão',
  'timeline.delete.title': 'Excluir esta sessão?',
  'timeline.delete.subtitle': 'Remove “{title}” e suas {tabs} salvas. Isso não pode ser desfeito.',
  'timeline.delete.body': 'Se mudar de ideia, ainda dá para recuperar as abas pelo histórico do navegador.',
  'timeline.delete.confirm': 'Excluir sessão',
  'timeline.delete.fallbackTitle': 'esta sessão',
  'timeline.offline.title': 'Você está offline',
  'timeline.offline.body': 'Seu vault funciona localmente — a sincronização retoma sozinha quando você voltar a ficar online.',
  'timeline.error.title': 'Não foi possível carregar sua linha do tempo',
  'timeline.error.body': 'Algo deu errado ao acessar o vault. Verifique sua conexão e tente de novo.',

  // ── search ─────────────────────────────────────────────────────────────
  'search.mode.text': 'Texto',
  'search.mode.hybrid': 'Híbrido',
  'search.mode.semantic': 'Semântico',
  'search.placeholder': 'Buscar no seu vault…',
  'search.clear': 'Limpar busca',
  'search.status.counted': 'BUSCANDO EM {count} ABAS',
  'search.status.default': 'BUSCANDO NO SEU VAULT',
  'search.empty.title': 'Busque em tudo o que você salvou',
  'search.empty.body':
    'Encontre uma aba pelo título, pelo endereço ou pelas palavras da página. O modo semântico encontra pelo significado.',
  'search.noMatch.title': 'Nada encontrado para “{q}”',
  'search.noMatch.body': 'Tente menos palavras ou palavras diferentes, mude para o modo Híbrido ou limpe os filtros.',
  'search.failed.eyebrow': '— A BUSCA FALHOU',
  'search.failed.body': 'Algo deu errado ao acessar seu vault.',
  'search.failed.retryHint': 'Tente mais uma vez.',
  'search.results': '{count} RESULTADOS',
  'search.sort.relevance': 'Relevância',
  'search.sort.date': 'Data',
  'search.loadMore': 'Carregar mais resultados',
  'search.bestMatch': 'MELHOR RESULTADO',
  'search.openedIn': 'VOCÊ ABRIU ISTO NO {browser}',
  'search.facet.browser': 'NAVEGADOR',
  'search.facet.date': 'DATA',
  'search.facet.topDomains': 'PRINCIPAIS DOMÍNIOS',
  'search.range.any': 'Qualquer data',
  'search.range.24h': '24 horas',
  'search.range.7d': '7 dias',
  'search.range.30d': '30 dias',
  'search.range.1y': '12 meses',
  'search.upsell.eyebrow': 'BUSCA SEMÂNTICA · PRO',
  'search.upsell.title': 'A busca semântica é um recurso Pro',
  'search.upsell.body':
    'Encontre abas pelo significado, não só por palavras-chave — “aquele artigo sobre corte de juros do banco central” em vez do título exato. Assine o Pro para buscar em tudo o que você já salvou.',
  'search.upsell.seePlans': 'Ver planos Pro',
  'search.upsell.useText': 'Buscar por texto',

  // ── duplicates ─────────────────────────────────────────────────────────
  'dupes.title': 'Central de duplicatas',
  'dupes.summary.duplicates': '{count} DUPLICATAS',
  'dupes.summary.ram': '≈ {ram} DE RAM PARA LIBERAR',
  'dupes.closeSelected': 'Fechar selecionadas ({count})',
  'dupes.keepNewest': 'Manter a mais nova, fechar o resto',
  'dupes.error.title': 'Não foi possível carregar suas duplicatas',
  'dupes.toast.closed': '{copies} fechadas',
  'dupes.toast.closedBody': 'A cópia mais recente continua aberta — todas as cópias seguem salvas no seu vault.',

  // ── collections ────────────────────────────────────────────────────────
  'collections.title': 'Coleções',
  'collections.subtitle': 'Organizadas por IA — renomeie ou mescle quando quiser',
  'collections.new': 'Nova coleção',
  'collections.banner.title': 'Coleções automáticas com IA são um recurso Pro.',
  'collections.banner.body': 'Você ainda pode criar e organizar coleções à mão — isso é grátis, para sempre.',
  'collections.empty.title': 'Nenhuma coleção ainda',
  'collections.empty.body':
    'Agrupe abas por assunto. Crie uma à mão — o Pro também organiza seu vault em coleções automaticamente.',
  'collections.error.title': 'Não foi possível carregar suas coleções',

  // ── import ─────────────────────────────────────────────────────────────
  'import.title': 'Importe seus velhos cemitérios de abas',
  'import.drop.title': 'Solte seu arquivo de exportação aqui',
  'import.drop.body': 'OneTab, Session Buddy ou HTML de favoritos —',
  'import.drop.browse': 'escolher arquivo',
  'import.readyEyebrow': 'PRONTO PARA IMPORTAR',

  // ── settings ───────────────────────────────────────────────────────────
  'settings.title': 'Configurações',
  'settings.section.account': 'CONTA E SYNC',
  'settings.section.browsers': 'NAVEGADORES CONECTADOS',
  'settings.section.capture': 'REGRAS DE CAPTURA',
  'settings.section.sharing': 'COMPARTILHAMENTO',
  'settings.section.storage': 'ARMAZENAMENTO',
  'settings.section.appearance': 'APARÊNCIA',
  'settings.section.language': 'IDIOMA',
  'settings.section.about': 'SOBRE',
  'settings.section.danger': 'ZONA DE PERIGO',
  'settings.account.private': 'PRIVADO E SEGURO',
  'settings.account.yourAccount': 'Sua conta',
  'settings.account.proPlan': 'PLANO PRO',
  'settings.account.freePlan': 'PLANO FREE',
  'settings.account.managePlan': 'Gerenciar plano',
  'settings.account.seePro': 'Conhecer o Pro',
  'settings.account.privacyNote':
    'Suas páginas salvas são privadas — só você pode vê-las. Nós as mantemos seguras e fora do alcance de todo mundo.',
  'settings.account.billing': 'Cobrança e pagamentos',
  'settings.browsers.syncAuto': 'Os outros sincronizam sozinhos',
  'settings.browsers.thisBrowser': 'Este navegador',
  'settings.browsers.webApp': 'APP WEB',
  'settings.browsers.activeNow': 'ATIVO AGORA',
  'settings.browsers.installHint':
    'Instale a extensão nos seus outros navegadores — eles aparecem aqui e sincronizam automaticamente.',
  'settings.capture.onDevice': 'NESTE DISPOSITIVO',
  'settings.capture.saveContent': 'Salvar o conteúdo da página para busca',
  'settings.capture.saveContentDesc': 'Só texto — guardado em privado para a busca de texto completo',
  'settings.capture.skipIncognito': 'Ignorar janelas anônimas',
  'settings.capture.neverOn': 'Nunca capturar conteúdo em:',
  'settings.capture.addSite': '+ adicionar site',
  'settings.capture.localNote':
    'Por enquanto essas regras vivem neste navegador — a sincronização entre dispositivos vem em breve.',
  'settings.sharing.readOnly': 'Links públicos somente leitura',
  'settings.sharing.collection': 'Coleção',
  'settings.sharing.sweep': 'Varredura',
  'settings.sharing.selectCollection': 'Escolha uma coleção…',
  'settings.sharing.selectSweep': 'Escolha uma varredura…',
  'settings.sharing.createLink': 'Criar link',
  'settings.sharing.empty.title': 'Nenhum link compartilhado ainda',
  'settings.sharing.empty.body': 'Crie um link público para uma coleção ou varredura — somente leitura.',
  'settings.sharing.copyLink': 'Copiar link',
  'settings.sharing.revoke': 'Revogar',
  'settings.toast.linkCreated': 'Link criado',
  'settings.toast.linkCreatedBody': 'Qualquer pessoa com o link pode ver — somente leitura.',
  'settings.toast.linkFailed': 'Não foi possível criar o link',
  'settings.toast.linkFailedBody': 'Tente de novo em instantes.',
  'settings.toast.linkRevoked': 'Link revogado',
  'settings.toast.linkRevokedBody': 'Esse link não abre mais.',
  'settings.toast.revokeFailed': 'Não foi possível revogar o link',
  'settings.toast.revokeFailedBody': 'Tente novamente.',
  'settings.toast.copied': 'Copiado',
  'settings.toast.copiedBody': 'O link está na sua área de transferência.',
  'settings.toast.deleteFailed': 'Falha ao excluir',
  'settings.toast.deleteFailedBody': 'Não conseguimos excluir a conta. Tente de novo.',
  'settings.danger.export': 'Exportar todos os dados',
  'settings.danger.deleteAccount': 'Excluir conta e dados',
  'settings.danger.note': 'Exporte primeiro — a exclusão é permanente após 14 dias.',
  'settings.storage.saved': '{count} salvos',
  'settings.storage.tabs': 'ABAS',
  'settings.storage.sessions': 'SESSÕES',
  'settings.storage.indexed': 'INDEXADAS',
  'settings.appearance.dark': 'Tema escuro',
  'settings.appearance.darkDesc': 'Azul-marinho profundo — o visual padrão',
  'settings.language.label': 'Idioma da interface',
  'settings.language.desc': 'Vale na hora, em todo o app.',
  'settings.promo.title': 'Instale a extensão',
  'settings.promo.body': 'Varra uma janela inteira com um clique, direto da barra de ferramentas.',
  'settings.about.webApp': 'App web',
  'settings.about.extension': 'Extensão',
  'settings.deleteModal.title': 'Excluir conta e dados',
  'settings.deleteModal.subtitle': 'Isso remove seu vault de todos os lugares.',
  'settings.deleteModal.body':
    'Cada varredura, página salva e coleção será agendada para exclusão. Fica recuperável por 14 dias, depois some para sempre. Exporte seus dados antes se puder querer de volta.',
  'settings.deleteModal.keep': 'Manter conta',
  'settings.deleteModal.confirm': 'Excluir tudo',
  'settings.planModal.title': 'Gerencie seu plano Pro',
  'settings.planModal.subtitle': 'O Free continua generoso — o Pro conecta tudo.',
  'settings.planModal.body':
    'Cancele quando quiser e o Pro vale até o fim do período pago. Depois: os salvamentos locais seguem ilimitados, a sincronização cai para um navegador, e a busca IA e as coleções pausam.',
  'settings.planModal.nothingDeleted': 'Nada é excluído.',
  'settings.planModal.emailSupport': 'Escrever ao suporte para cancelar',
  'settings.planModal.keepPro': 'Manter o Pro',

  // ── login / verify ─────────────────────────────────────────────────────
  'login.welcome': 'Boas-vindas ao TabVault',
  'login.tagline': 'Um vault só para todos os seus navegadores.',
  'login.emailPlaceholder': 'voce@email.com',
  'login.sendLink': 'Enviar link mágico',
  'login.error.tooMany': 'Muitas tentativas — espere um minuto e tente de novo.',
  'login.error.sendFailed': 'Não conseguimos enviar o link agora. Tente em instantes.',
  'login.reassure': 'Suas páginas salvas são privadas — só você pode abrir seu vault.',
  'login.checkInbox': 'Confira sua caixa de entrada',
  'login.sentTo': 'Enviamos um link de acesso para',
  'login.expires': 'O LINK EXPIRA EM 15 MIN',
  'login.nothingThere': 'Não chegou nada?',
  'login.checkSpam': 'veja o spam',
  'login.wrongAddress': '← Endereço errado? Voltar',
  'login.devDivider': 'DEV · COLE O TOKEN',
  'login.tokenPlaceholder': 'token do console da API',
  'verify.signingIn': 'Entrando…',
  'verify.hangTight': 'Só um instante, isso leva um segundo.',
  'verify.expired.title': 'Este link expirou',
  'verify.expired.body':
    'Links mágicos valem por 15 minutos e um único uso. Peça um novo e você entra na hora.',
  'verify.backToSignIn': 'Voltar ao login',

  // ── onboarding ─────────────────────────────────────────────────────────
  'onboarding.hero.title1': 'Seu navegador finalmente',
  'onboarding.hero.title2': 'tem memória.',
  'onboarding.hero.body':
    'Varra janelas inteiras para o seu vault, feche-as sem medo e encontre qualquer página de novo — pelo que estava escrito nela.',
  'onboarding.getStarted': 'Começar',
  'onboarding.hero.micro': 'LEVA 60 SEGUNDOS · NÃO PRECISA DE CONTA PARA EXPLORAR',
  'onboarding.perm.title': 'Por que o navegador pede acesso',
  'onboarding.perm.lede': 'O próximo aviso parece assustador. Eis o que ele significa de verdade.',
  'onboarding.perm.head': '“LER E ALTERAR TODOS OS SEUS DADOS EM TODOS OS SITES” — TRADUZIDO',
  'onboarding.perm.p1.title': 'Lemos as páginas só para torná-las buscáveis',
  'onboarding.perm.p1.body': 'Para você achar depois “aquele artigo sobre taxas de financiamento”.',
  'onboarding.perm.p2.title': 'Suas páginas ficam privadas no seu dispositivo',
  'onboarding.perm.p2.body': 'Só você pode abrir seu vault — não vemos o que você salva.',
  'onboarding.perm.p3.title': 'Bancos, e-mail e sites privados podem ser excluídos',
  'onboarding.perm.p3.body': 'Uma lista nas Configurações — lá o conteúdo nunca é capturado.',
  'onboarding.perm.continue': 'Parece justo — continuar',
  'onboarding.perm.later': 'Perguntar depois',
  'onboarding.perm.micro': 'DÁ PARA MUDAR ISSO A QUALQUER HORA NAS CONFIGURAÇÕES',
  'onboarding.rescue.title': 'Resgate suas abas agora mesmo',
  'onboarding.rescue.lede': 'Escolha um caminho — os dois levam menos de um minuto, e nada se perde.',
  'onboarding.rescue.onetab.title': 'Importar do OneTab',
  'onboarding.rescue.onetab.body':
    'Traga seu cemitério inteiro do OneTab com um clique — grupos viram sessões.',
  'onboarding.rescue.chooseFile': 'Escolher arquivo',
  'onboarding.rescue.onetab.foot': 'TAMBÉM: SESSION BUDDY · HTML DE FAVORITOS',
  'onboarding.rescue.ext.title': 'Instale a extensão do navegador',
  'onboarding.rescue.ext.body':
    'Varra uma janela inteira com um clique, direto da barra de ferramentas. Veja sua RAM voltar.',
  'onboarding.rescue.ext.foot': 'CHROME · EDGE · YANDEX · COMET',
  'onboarding.rescue.openApp': 'Abrir o app web →',

  // ── pricing ────────────────────────────────────────────────────────────
  'pricing.title': 'Assine o Pro quando estiver pronto',
  'pricing.subtitle': 'O Free continua generoso. O Pro conecta tudo.',
  'pricing.monthly': 'Mensal ${price}',
  'pricing.yearly': 'Anual ${price}',
  'pricing.forever': 'PARA SEMPRE',
  'pricing.yourPlan': 'SEU PLANO',
  'pricing.mostLoved': 'O MAIS AMADO',
  'pricing.perMonth': '/MÊS',
  'pricing.perMonthYearly': '/MÊS · ${total} POR ANO',
  'pricing.free.f1': 'Salvamentos locais ilimitados',
  'pricing.free.f2': '1 navegador sincronizado na nuvem',
  'pricing.free.f3': 'Busca por título e URL',
  'pricing.free.f4': 'Busca de texto completo e IA',
  'pricing.free.f5': 'Coleções com IA',
  'pricing.pro.f1': 'Todos os navegadores e dispositivos sincronizados',
  'pricing.pro.f2': 'Texto completo + busca semântica com IA',
  'pricing.pro.f3': 'Coleções IA que se organizam sozinhas',
  'pricing.pro.f4': 'Histórico de versões das páginas salvas',
  'pricing.pro.f5': 'Suporte prioritário',
  'pricing.stayFree': 'Ficar no Free',
  'pricing.youreOnPro': 'Você já é Pro',
  'pricing.signInToUpgrade': 'Entre para assinar',
  'pricing.checkoutSoon': 'O pagamento abre em breve — avisaremos por e-mail assim que estiver no ar.',
  'pricing.checkoutFailed': 'Algo deu errado ao iniciar o pagamento. Tente de novo.',
  'pricing.footer': 'CANCELE QUANDO QUISER · EXPORTE SEUS DADOS SEMPRE · SALVAMENTOS LOCAIS NUNCA SÃO BLOQUEADOS',

  // ── billing / version history ──────────────────────────────────────────
  'billing.title': 'Cobrança e pagamentos',
  'versions.title': 'Histórico de versões',
  'versions.current': 'ATUAL',
  'versions.restoreThis': 'Restaurar esta versão',

  // ── trash ──────────────────────────────────────────────────────────────
  'trash.title': 'Lixeira',
  'trash.autoPurge': 'LIMPEZA AUTOMÁTICA APÓS 14 DIAS',
  'trash.itemsLoading': '… ITENS',
  'trash.restoreSelected': 'Restaurar selecionados ({count})',
  'trash.restoring': 'Restaurando…',
  'trash.emptyTrash': 'Esvaziar lixeira',
  'trash.error.title': 'Não foi possível carregar a lixeira',
  'trash.emptyState.title': 'A lixeira está vazia',
  'trash.emptyState.body':
    'Sessões e páginas excluídas esperam aqui por 14 dias, depois são apagadas automaticamente.',
  'trash.footNote': 'EXCLUIR DA LIXEIRA É PERMANENTE · EXPORTE SEUS DADOS EM CONFIGURAÇÕES → ZONA DE PERIGO',
  'trash.purge.title': 'Excluir para sempre?',
  'trash.purge.subtitle': '“{title}” será removida permanentemente — sem os 14 dias de recuperação.',
  'trash.purge.confirm': 'Excluir para sempre',
  'trash.purge.sweepBody': 'Isso exclui a sessão e suas {tabs} de vez.',
  'trash.purge.pageBody': 'Isso exclui a página salva e o conteúdo capturado de vez.',
  'trash.emptyConfirm.title': 'Esvaziar a lixeira?',
  'trash.emptyConfirm.subtitle': 'Exclui permanentemente {entries}.',
  'trash.emptyConfirm.body':
    'Tudo na lixeira some para sempre — não dá para desfazer. Você pode exportar seus dados a qualquer momento em Configurações → Zona de perigo.',
  'trash.toast.restored': 'Restaurado',
  'trash.toast.restoredBody': '“{title}” voltou para o seu vault.',
  'trash.toast.restoredMany': '{entries} restauradas',
  'trash.toast.restoreFailed': 'Não foi possível restaurar',
  'trash.toast.restoreManyFailed': 'Não foi possível restaurar a seleção',
  'trash.toast.purged': 'Excluído para sempre',
  'trash.toast.purgedBody': '“{title}” se foi de vez.',
  'trash.toast.purgeFailed': 'Não foi possível excluir',
  'trash.toast.emptied': 'Lixeira esvaziada',
  'trash.toast.emptiedBody': 'Tudo que estava na lixeira foi excluído permanentemente.',
  'trash.toast.emptyFailed': 'Não foi possível esvaziar a lixeira',
};
